import React, { useEffect, Fragment, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import withDashboard from "../../HOC/withDashboard";
import Pagination from "../../components/Pagination";
import {
  fetchGiftCardCategories,
  fetchGiftCards,
  updateGiftCard,
  updateGiftCategoryStatus,
  updateGiftCardRates,
} from "../../services/GiftCardServices";
import {
  Button,
  Card,
  IconButton,
  Switch,
  CircularProgress,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import Swal from "sweetalert2";
import "./index.css";
import Loader from "../../components/Loader";
import CardData from "./CardData";
import CardCategoriesData from "./CardCategoriesData";

const GiftCards = () => {
  const dispatch = useDispatch();

  // State for paginated data
  const [paginatedCategories, setPaginatedCategories] = React.useState([]);
  const [paginatedCards, setPaginatedCards] = React.useState([]);

  // Pagination states for categories
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingCard, setIsLoadingCard] = useState(false);
  // Pagination states for cards
  const [totalCardDataRecord, setTotalCardDataRecordd] = useState(0);
  const [cardData, setCardData] = React.useState([]);
  const [cardDataFilter, setCardDataFilter] = useState({
    search: "",
    page: 0,
    limit: 10,
  });
  const [totalcategoryDataRecord, setTotalcategoryDataRecordd] = useState(0);
  const [categoryData, setCategoryData] = React.useState([]);
  const [categoryDataFilter, setCategoryDataFilter] = useState({
    search: "",
    page: 0,
    limit: 10,
  });

  useEffect(() => {
    getGiftCards();
  }, [cardDataFilter]);

  useEffect(() => {
    getGiftCardsCategories();
  }, [categoryDataFilter]);

  const onChangeCardFilter = (name, value) => {
    setCardDataFilter({ ...cardDataFilter, [name]: value });
  };

  const onChangeCategoryFilter = (name, value) => {
    setCategoryDataFilter({ ...categoryDataFilter, [name]: value });
  };

  const getGiftCards = () => {
    setIsLoadingCard(true);
    dispatch(fetchGiftCards(cardDataFilter))
      .then((res) => {
        setTotalCardDataRecordd(res?.data?.data?.total);
        setCardData(res?.data?.data?.data);
        setIsLoadingCard(false);
      })
      .catch(({ message, errorData, statusCode }) => {
        console.error("Error fetching gift card categories:", message);
        setIsLoadingCard(false);
      });
  };

  const getGiftCardsCategories = () => {
    setIsLoading(true);
    dispatch(fetchGiftCardCategories(categoryDataFilter))
      .then((res) => {
        setTotalcategoryDataRecordd(res?.data?.data?.total);
        setCategoryData(res?.data?.data?.data);
        setIsLoading(false);
      })
      .catch(({ message, errorData, statusCode }) => {
        console.error("Error fetching gift card categories:", message);
        setIsLoading(false);
      });
  };

  const handleUpdateGiftData = async () => {
    setIsLoading(true);
    setIsLoadingCard(true);
    dispatch(updateGiftCardRates())
      .then((res) => {
        setIsLoading(false);
        setIsLoadingCard(false);
        getGiftCards();
        Swal.fire("Success", "Gift card data updated successfully", "success");
      })
      .catch(({ message, errorData, statusCode }) => {
        Swal.fire("Error", "Failed to update gift data", "error");
        setIsLoading(false);
        setIsLoadingCard(false);
      });
  };

  const handleCategoryCardUpdate = async (cardId, status) => {
    const { value: formValues } = await Swal.fire({
      title: "Update Category Card",
      html:
        '<input id="swal-rate" class="swal2-input" placeholder="Rate">' +
        '<select id="swal-status" class="swal2-input"><option value="active">Active</option><option value="inactive">Inactive</option></select>',
      focusConfirm: false,
      preConfirm: () => {
        return {
          rate: document.getElementById("swal-rate").value,
          status: document.getElementById("swal-status").value === status,
        };
      },
    });

    if (formValues) {
      const updates = {};
      if (formValues.rate) {
        updates.rate = formValues.rate;
      }
      if (formValues.status !== undefined) {
        updates.status = formValues.status === true ? "active" : "inactive";
      }
      setIsLoadingCard(true);
      dispatch(updateGiftCategoryStatus(cardId, updates))
        .then((res) => {
          setIsLoadingCard(false);
          getGiftCardsCategories();
          getGiftCards();
          Swal.fire("Success", "Category Card updated successfully", "success");
        })
        .catch(({ message, errorData, statusCode }) => {
          Swal.fire("Error", "Failed to update Category Card", "error");
          setIsLoadingCard(false);
        });
    }
  };

  const handleCardStatusChange = async (cardId, currentStatus) => {
    console.log({ cardId, currentStatus });
    setIsLoading(true);
    dispatch(
      updateGiftCard(cardId, {
        status: currentStatus === "active" ? "inactive" : "active",
      })
    )
      .then((res) => {
        setIsLoading(false);
        getGiftCards();
        Swal.fire("Success", "Card status updated successfully", "success");
      })
      .catch(({ message, errorData, statusCode }) => {
        Swal.fire("Error", "Failed to update Card status", "error");
        setIsLoading(false);
      });
  };

  return (
    <Fragment>
      <div className="gift-cards-container">
        <div className="gift-cards-button-container">
          <Button
            variant="contained"
            color="primary"
            onClick={handleUpdateGiftData}
            disabled={isLoading}
            className="gift-cards-button"
          >
            {isLoading ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              "Update Gift Data"
            )}
          </Button>
        </div>

        {/* Gift Card Categories Section */}
        <CardCategoriesData
          isLoading={isLoading}
          data={categoryData}
          dataFilter={categoryDataFilter}
          totalDataRecord={totalcategoryDataRecord}
          onChangePage={onChangeCategoryFilter}
          handleUpdate={handleCategoryCardUpdate}
        />
        {/* Gift Cards Section */}
        <CardData
          isLoading={isLoadingCard}
          data={cardData}
          dataFilter={cardDataFilter}
          totalDataRecord={totalCardDataRecord}
          onChangePage={onChangeCardFilter}
          handleUpdate={handleCardStatusChange}
        />
      </div>
      <Loader />
    </Fragment>
  );
};

export default withDashboard(GiftCards);
